import { render, staticRenderFns } from "./RulesSettings.vue?vue&type=template&id=ff60d2b2"
import script from "./RulesSettings.vue?vue&type=script&lang=js"
export * from "./RulesSettings.vue?vue&type=script&lang=js"
import style0 from "./RulesSettings.vue?vue&type=style&index=0&id=ff60d2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports